module.exports = __webpack_public_path__ + "static/media/lvjian-dashuju.1209daad.png";